module.exports = __webpack_public_path__ + "img/arnicaV2.fef99cb3.png";